import React from 'react';
import { connect } from 'react-redux';
import classes from './SeatsSelectPax.scss';
import * as farePriceActions from '../../../../../store/actions/index';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const seatsSelectPax = (props) => {
    let updatePresent = false;
    let passengersSelected = [];
    let passengersUnSelected = [];
    for(let i = 0; i < props.passengers.length; i++) {
        if (props.passengers[i].ssrDetails.ssrSeatDetails[props.seatsFlow === 'O' ? 0 : 1][props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal].seatValue !== "") {
            passengersSelected.push(props.passengers[i]);
        } else {
            passengersUnSelected.push(props.passengers[i]);
        }
    }

    const tempPassengers = passengersUnSelected.concat(passengersSelected);
    return (
        <div className={classes.SelectPax}>
            <div className={`u-flex justify-content-between align-items-center pt-4 pb-4 pl-3 pr-3`}>
                <span className={`u-textColorWhite u-fontSize16 u-fontWeightRegular`}>Seat {props.seatNo}</span>
                { props.price === 0 ? <span className={`u-textUppercase u-fontSize13 u-fontWeightMedium u-color-green`}>Free</span> : <span className={`u-textUppercase u-fontSize13 u-fontWeightMedium u-color-green`}>&#8377; {props.price}</span> }
            </div>
            {props.passengers.length !== 1 ? (
                <React.Fragment>
                <div className={classes.Divider}></div>
                <div className={classes.Secondary}>
                    {props.selectedSeats.includes(props.savedSeat.seatValue) ? (
                        <ul>
                            {props.passengers.map((passenger, index) => {
                                if(passenger.isSelected && passenger.travellerDetails.passengerClass !== 'INF') {
                                    if(passenger.ssrDetails.ssrSeatDetails[props.seatsFlow === 'O' ? 0 : 1][props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal].seatValue === props.savedSeat.seatValue) {
                                        return (<li key={index} className={classes.PaxListItem}>
                                                    <span>{passenger.travellerDetails.firstName + ' ' + passenger.travellerDetails.lastName.substring(0, 1) + '.'}</span>
                                                    <div 
                                                        onClick={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        props.onRemoveAddon("Seats", parseInt(passenger.ssrDetails.ssrSeatDetails[props.seatsFlow === 'O' ? 0 : 1][props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal].price, 10), props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal, props.seatsFlow === 'O' ? 'O' : 'R');
                                                        props.onDeselectSeat(passenger.paxID, props.seatsFlow)}} className={`ml-auto`}>
                                                        <div className={`u-block u-backgroundColorWhite u-borderRadius50 u-widthAuto u-heightAuto`}>
                                                            <FontAwesomeIcon icon="check-circle" color="#3E72F7" size="lg" />
                                                        </div>
                                                        </div>
                                                </li>);
                                    } else {
                                        return null;
                                    }
                                } else {
                                    return null;
                                }
                            })}
                        </ul>
                    ) : (
                        <ul className={classes.PaxList}>
                            {tempPassengers.map(passenger => {
                                if(passenger.ssrDetails.ssrSeatDetails[props.seatsFlow === 'O' ? 0 : 1][props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal].seatValue !== "") {
                                    updatePresent = true;
                                }
                                return null;
                            })}
                            {tempPassengers.map((passenger, index) => {
                                if(passenger.isSelected && passenger.travellerDetails.passengerClass !== 'INF') {
                                    if(passenger.ssrDetails.ssrSeatDetails[props.seatsFlow === 'O' ? 0 : 1][props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal].seatValue === "") {
                                        return <li key={index} onClick={() => {
                                            console.log("Reached pax");
                                            props.onSelectSeat(passenger.paxID, props.seatsFlow)
                                            props.onAddAddon({addonLabel: "Seats", amount: parseInt(props.price, 10), legIndex: props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal, leg: props.seatsFlow === 'O' ? 'O' : 'R'})
                                        }
                                        } className={classes.PaxListItem}>{passenger.travellerDetails.firstName + ' ' + passenger.travellerDetails.lastName} <span style={{marginRight: updatePresent ? '1rem' : '0'}} className={classes.EmptyCheckBox}></span></li>
                                    } else {
                                        return <li key={index} className={classes.PaxListItem}>
                                        <span>{passenger.travellerDetails.firstName + ' ' + passenger.travellerDetails.lastName.substring(0, 1) + '.'}</span>
                                        <span
                                            className={`u-textColorPrimary u-fontSize13 ml-auto`} 
                                            onClick={() => {
                                                console.log("Reached pax 2")
                                                props.onRemoveAddon("Seats", parseInt(passenger.ssrDetails.ssrSeatDetails[props.seatsFlow === 'O' ? 0 : 1][props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal].price, 10), props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal, props.seatsFlow === 'O' ? 'O' : 'R');
                                                props.onDeselectSeat(passenger.paxID, props.seatsFlow);
                                                props.onSelectSeat(passenger.paxID, props.seatsFlow);
                                                props.onAddAddon({addonLabel: "Seats", amount: props.price, legIndex: props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal, leg: props.seatsFlow === 'O' ? 'O' : 'R', paxID: passenger.paxID})
                                            }}>Update</span></li>;
                                    }
                                } else {
                                    return null;
                                }
                            })}
                        </ul>
                    )}
                </div>
                </React.Fragment>
            ) : props.passengers.length === 1 && props.passengers[0].ssrDetails.ssrSeatDetails[props.seatsFlow === 'O' ? 0 : 1][props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal].seatValue === props.savedSeat.seatValue ? (
                <React.Fragment>
                    <div className={classes.Divider}></div>
                    <div className={classes.Secondary}>
                        <ul className={classes.PaxList}>
                            <li onClick={() => {
                                console.log("Here");
                                props.onSelectSeat(props.passengers[0].paxID, props.seatsFlow)}} className={classes.PaxListItem}>
                                <span>{props.passengers[0].travellerDetails.firstName + ' ' + props.passengers[0].travellerDetails.lastName.substring(0, 1) + '.'}</span>
                                <div 
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    props.onRemoveAddon("Seats", parseInt(props.passengers[0].ssrDetails.ssrSeatDetails[props.seatsFlow === 'O' ? 0 : 1][props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal].price, 10), props.seatsFlow === 'O' ? props.seatsViewOVal : props.seatsViewRVal, props.seatsFlow === 'O' ? 'O' : 'R');
                                    props.onDeselectSeat(props.passengers[0].paxID, props.seatsFlow)}} style={{marginLeft: 'auto'}}>
                                        <div className={`u-block u-backgroundColorWhite u-borderRadius50 u-widthAuto u-heightAuto`}>
                                            <FontAwesomeIcon icon="check-circle" color="#3E72F7" size="lg" />
                                        </div>
                                    </div>
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            ) : null }
        </div>
    );
}

const mapStateToProps = state => {
    return {
        passengers: state.farePrice.passengers,
        seatsFlow: state.farePrice.seatsFlow,
        seatsViewOVal: state.farePrice.seatsViewOneWayVal,
        seatsViewRVal: state.farePrice.seatsViewReturnVal,
        savedSeat: state.farePrice.savedSeat,
        selectedSeats: state.farePrice.selectedSeats,
        seatClicked: state.seats.seatClicked
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSelectSeat: (id, flow) => dispatch(farePriceActions.selectSeat(id, flow)),
        onDeselectSeat: (id, flow) => dispatch(farePriceActions.deselectSeat(id, flow)),
        onAddAddon: (addon) => dispatch(farePriceActions.addAddon(addon)),
        onRemoveAddon: (label, amount, legIndex, leg) => dispatch(farePriceActions.removeAddon(label, amount, legIndex, leg))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(seatsSelectPax);


// WEBPACK FOOTER //
// ./src/components/Addons/Seats/SeatsMap/SeatsSelectPax/SeatsSelectPax.js